import { RECEIPT_SCOPE_BUNDLE } from "./receipt";

export const GOOGLE_SCOPE_BUNDLES = {
  receipt: RECEIPT_SCOPE_BUNDLE,
  bundle: "bundle_base" as const,
  calendarToday: "calendar_today_read" as const,
} as const;

export type GoogleScopeBundle =
  (typeof GOOGLE_SCOPE_BUNDLES)[keyof typeof GOOGLE_SCOPE_BUNDLES];

export type GoogleLinkMode = "single" | "selector" | "all";

export type GoogleIndividualScopeBundle =
  | typeof GOOGLE_SCOPE_BUNDLES.bundle
  | typeof GOOGLE_SCOPE_BUNDLES.calendarToday;

export type GoogleScopeGrantedMap = Record<GoogleIndividualScopeBundle, boolean>;

export type GoogleIntegrationAggregateState = "none" | "partial" | "full";

export const GOOGLE_SCOPE_BUNDLES_FOR_ALL: GoogleIndividualScopeBundle[] = [
  GOOGLE_SCOPE_BUNDLES.calendarToday,
];

export function createDefaultGoogleScopeGrantedMap(): GoogleScopeGrantedMap {
  return {
    [GOOGLE_SCOPE_BUNDLES.bundle]: false,
    [GOOGLE_SCOPE_BUNDLES.calendarToday]: false,
  };
}

export function isGoogleScopeBundle(value: unknown): value is GoogleScopeBundle {
  return (
    value === GOOGLE_SCOPE_BUNDLES.receipt ||
    value === GOOGLE_SCOPE_BUNDLES.bundle ||
    value === GOOGLE_SCOPE_BUNDLES.calendarToday
  );
}

export function isGoogleLinkMode(value: unknown): value is GoogleLinkMode {
  return value === "single" || value === "selector" || value === "all";
}

export function getGoogleScopeBundleLabel(scopeBundle: GoogleScopeBundle): string {
  if (scopeBundle === GOOGLE_SCOPE_BUNDLES.bundle) return "領収書整理用のGoogle Drive連携";
  if (scopeBundle === GOOGLE_SCOPE_BUNDLES.calendarToday) return "カレンダー連携";
  return "領収書整理用のGoogle Drive連携";
}

export function resolveGoogleIntegrationAggregateState(
  scopeGrantedMap: GoogleScopeGrantedMap
): GoogleIntegrationAggregateState {
  const grantedCount = GOOGLE_SCOPE_BUNDLES_FOR_ALL.filter((scopeBundle) => scopeGrantedMap[scopeBundle]).length;

  if (grantedCount <= 0) return "none";
  if (grantedCount >= GOOGLE_SCOPE_BUNDLES_FOR_ALL.length) return "full";
  return "partial";
}

export function getGoogleIntegrationAggregateStatusLabel(
  aggregateState: GoogleIntegrationAggregateState
): string {
  if (aggregateState === "full") return "全て連携";
  if (aggregateState === "partial") return "一部連携";
  return "未連携";
}

export function getGoogleIntegrationAggregateStatusDescription(
  aggregateState: GoogleIntegrationAggregateState
): string {
  if (aggregateState === "full") {
    return "領収書整理・カレンダー連携に必要な設定が完了しています。";
  }
  if (aggregateState === "partial") {
    return "外部連携設定が一部完了しています。";
  }
  return "領収書整理・カレンダー連携に使います。";
}

export function resolveNextGoogleScopeBundleForAllConsent(
  scopeGrantedMap: GoogleScopeGrantedMap
): GoogleScopeBundle | null {
  for (const scopeBundle of GOOGLE_SCOPE_BUNDLES_FOR_ALL) {
    if (!scopeGrantedMap[scopeBundle]) {
      return scopeBundle;
    }
  }
  return null;
}
